import Reveal from "@/components/base/Reveal";
import { archiveData } from "@/mocks/homeData";

type ArchiveSectionProps = {
  onAction: (message: string) => void;
};

export default function ArchiveSection({ onAction }: ArchiveSectionProps) {
  return (
    <section id="archive" className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-14 md:px-8 md:py-20">
        <Reveal className="max-w-2xl">
          <span className="font-label text-xs tracking-[0.2em] text-secondary-600">FULL RECORD</span>
          <h3 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            完整版全记录 · 分册归档
          </h3>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            按事件的四个阶段分册存放。每册都把当时能拿到的素材原样保留，方便日后对照与回看。
          </p>
        </Reveal>

        <div className="mt-12 space-y-12 md:space-y-16">
          {archiveData.map((item, index) => (
            <Reveal key={item.id}>
              <article className="grid gap-6 lg:grid-cols-2 lg:items-center lg:gap-12">
                <div className={`w-full ${index % 2 === 1 ? "lg:order-2" : ""}`}>
                  <div className="h-56 w-full overflow-hidden rounded-lg border border-background-200/80 sm:h-72 lg:h-80">
                    <img
                      src={item.img}
                      alt={`超碰吃瓜${item.step}档案`}
                      title={`超碰吃瓜时间线 · ${item.title}`}
                      className="h-full w-full object-cover object-top transition-transform duration-700 hover:scale-105"
                    />
                  </div>
                </div>

                <div className={index % 2 === 1 ? "lg:order-1" : ""}>
                  <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 font-label text-xs tracking-[0.16em] text-accent-800">
                    <span className="flex h-3.5 w-3.5 items-center justify-center">
                      <i className="ri-folder-3-line text-sm"></i>
                    </span>
                    {item.step} 档案
                  </span>
                  <h4 className="mt-4 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
                    {item.title}
                  </h4>
                  <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">{item.desc}</p>

                  <div className="mt-5 flex flex-wrap gap-2">
                    {item.tags.map((tag) => (
                      <span
                        key={tag}
                        className="rounded-md border border-background-200 bg-background-50 px-3 py-1.5 text-xs text-foreground-600"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>

                  <button
                    type="button"
                    onClick={() => onAction(`「${item.title}」已加入下载队列（演示）`)}
                    className="mt-6 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-primary-300 bg-primary-50 px-4 py-2.5 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-100"
                  >
                    <span className="flex h-4 w-4 items-center justify-center">
                      <i className="ri-add-circle-line text-base"></i>
                    </span>
                    加入下载队列
                  </button>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}